module.exports = __webpack_public_path__ + "img/Fragezeichen_2020_000.98b11616.svg";